import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface"; // Ensure correct path

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Selection,
  onChange, // Add this line
  pagination, // Add this line to destructure the pagination prop
  onSearch,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);

  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    onSearch(value);
  };

  const handleTableChange = (pagination: any) => {
    onChange(pagination); // Call the new onChange prop
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    return setSelections(Selection);
  }, [Selection]);

  return (
    <>
      <div className="table-top-data d-flex px-3 justify-content-between">
        <div className="page-range"></div>
        
      </div>
      <Table
        className="table datanew dataTable no-footer"
        columns={columns}
        rowSelection={Selections ? rowSelection : undefined}
        dataSource={filteredDataSource}
        pagination={pagination}
        onChange={handleTableChange} // Use handleTableChange here
      />
    </>
  );
};

export default Datatable;


